var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 7.375V17.5M9.625 7.375C10.6605 7.375 11.5 6.53553 11.5 5.5C11.5 4.46447 10.6605 3.625 9.625 3.625M9.625 7.375C8.58947 7.375 7.75 6.53553 7.75 5.5C7.75 4.46447 8.58947 3.625 9.625 3.625M9.625 1V3.625M16.375 14.875V17.5M16.375 14.875C17.4105 14.875 18.25 14.0355 18.25 13C18.25 11.9645 17.4105 11.125 16.375 11.125M16.375 14.875C15.3395 14.875 14.5 14.0355 14.5 13C14.5 11.9645 15.3395 11.125 16.375 11.125M16.375 1V11.125M2.875 11.875V17.5M2.875 11.875C3.91053 11.875 4.75 11.0355 4.75 10C4.75 8.96447 3.91053 8.125 2.875 8.125M2.875 11.875C1.83947 11.875 1 11.0355 1 10C1 8.96447 1.83947 8.125 2.875 8.125M2.875 1V8.125",
    stroke: "#5F5F5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.359d9f740b9639bff88b944b72b7bd95.svg";
export { ForwardRef as ReactComponent };